import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmartGridComponent, ColDef, GridConfig } from 'app/shared/components/smart-grid';
import { MOCK_ORDERS, MockOrder } from '../mock-data/mock-orders.data';

/**
 * Basic Grid Example
 * Shows the simplest possible grid configuration
 */
@Component({
  selector: 'app-basic-example',
  standalone: true,
  imports: [CommonModule, SmartGridComponent],
  template: `
    <div class="p-6">
      <div class="mb-4">
        <h2 class="text-2xl font-bold mb-2">Ejemplo Básico</h2>
        <p class="text-gray-600">
          Grid simple con columnas básicas, sin configuración avanzada.
          Muestra {{ orders.length }} pedidos.
        </p>
      </div>

      <div class="bg-white dark:bg-gray-800 rounded-lg shadow">
        <app-smart-grid
          [data]="orders"
          [columnDefs]="columnDefs"
          [config]="gridConfig">
        </app-smart-grid>
      </div>

      <div class="mt-4 p-4 bg-blue-50 dark:bg-blue-900 rounded">
        <h3 class="font-semibold mb-2">💡 Código de este ejemplo:</h3>
        <pre class="text-xs overflow-x-auto"><code>{{exampleCode}}</code></pre>
      </div>
    </div>
  `,
})
export class BasicExampleComponent {
  orders: MockOrder[] = MOCK_ORDERS;

  columnDefs: ColDef<MockOrder>[] = [
    {
      field: 'serial',
      headerName: 'Nro. Documento',
      width: 180,
    },
    {
      field: 'soldTo.name',
      headerName: 'Cliente',
      width: 200,
    },
    {
      field: 'class.name',
      headerName: 'Clase',
      width: 150,
    },
    {
      field: 'total',
      headerName: 'Total',
      width: 120,
      valueFormatter: (value) => `${value.toFixed(2)}`,
    },
    {
      field: 'createdAt',
      headerName: 'Fecha',
      width: 150,
      valueFormatter: (value) => new Date(value).toLocaleDateString(),
    },
  ];

  gridConfig: GridConfig<MockOrder> = {
    pagination: {
      enabled: true,
      pageSize: 20,
    },
    styling: {
      maxHeight: '600px', // Limita la altura del grid
    },
  };

  exampleCode = `// Component Code
columnDefs: ColDef<MockOrder>[] = [
  { field: 'serial', headerName: 'Nro. Documento' },
  { field: 'soldTo.name', headerName: 'Cliente' },
  { field: 'total', headerName: 'Total',
    valueFormatter: (value) => \` \${value.toFixed(2)}\` },
];

gridConfig: GridConfig<MockOrder> = {
  pagination: { enabled: true, pageSize: 20 },
  styling: { maxHeight: '600px' } // Limita altura
};

// Template
<app-smart-grid
  [data]="orders"
  [columnDefs]="columnDefs"
  [config]="gridConfig">
</app-smart-grid>`;
}
